/** Cópia sem as chaves indicadas (sem `delete` dinâmico). */
export function omitKeys<T>(obj: Record<string, T>, keys: Iterable<string>): Record<string, T> {
  const drop = new Set(keys);
  return Object.fromEntries(Object.entries(obj).filter(([k]) => !drop.has(k)));
}
